import * as types from '../mutation-types'

const state = {
	running: false
}

const mutations = {
	[types.SET_SIMULATOR_RUNNING](state, running) {
		state.running = running;
	}
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/simulator.js